@if (product$ | async; as product) { @if (!product.failed) {
<div class="product-tile-list row align-items-md-center product-retail-set" [attr.data-testing-sku]="product.sku">
  <div class="col-3 p-0 pl-1">
    <div class="product-image-container">
      <ish-product-image imageType="M" [link]="true" />
      <ish-product-label />
      <!-- DIAS Customization - Marketing Bug -->
      <custom-product-marketing-label />
    </div>
  </div>
  <div class="col-9">
    <div class="row">
      <div class="col-lg-7">
        <ish-product-name />
        @if (configuration$('ratings') | async) {
        <ish-lazy-product-rating [hideNumberOfReviews]="true" />
        } @if (configuration$('price') | async) {
        <ish-product-price [showInformationalPrice]="true" />
        }
        <ish-product-id />
        @if (configuration$('description') | async) {
        <div class="product-description" [ishServerHtml]="product.shortDescription"></div>
        }
        <!-- <ish-product-promotion displayType="simpleWithDetail"></ish-product-promotion> -->
        <!-- <div class="product-tile-actions btn-group">
            <ish-lazy-product-add-to-quote displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-quote>
            <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-compare>
            <ish-lazy-product-add-to-wishlist displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-wishlist>
            <ish-lazy-product-add-to-order-template
              displayType="icon"
              cssClass="btn-link"
            ></ish-lazy-product-add-to-order-template>
          </div> -->
      </div>
      <div class="col-lg-5">
        @if (configuration$('isRetailPart') | async) {
        <ish-product-price [showInformationalPrice]="true" />
        }
        <ish-product-inventory />
        <ish-product-item-variations />
        <div class="product-list-actions-container">
          <div class="product-form form-horizontal row justify-content-md-end">
            @if (configuration$('readOnly') | async) {
            <div class="action-container col-12 col-xl-7">
              @if (configuration$('quantity') | async) {
              <span>{{ 'product.quantity.label' | translate }}: {{ quantity$ | async }}</span>
              }
            </div>
            } @else {
            <div class="action-container col-lg-5">
              <ish-product-quantity />
            </div>
            }
            <!-- <div class="action-container addtocart-container col-12 col-lg-7">
                <ish-product-add-to-basket></ish-product-add-to-basket>
                <ish-product-choose-variation></ish-product-choose-variation>
              </div> -->
          </div>
          <ish-product-shipment />
          <!-- <a *ishFeature="'quickView'" [routerLink]="[]" (click)="openQuickView(product.sku)">
            <span class="product-variation">QUICK VIEW</span>
          </a> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="product-list-buttons-container">
        <div class="product-list-actions">
          <ish-lazy-product-add-to-order-template
            displayType="icon"
            cssClass="btn-link product-list-action-buttons btn-circle list-border"
          />
          <ish-lazy-product-add-to-compare
            displayType="icon"
            cssClass="btn-link product-list-action-buttons btn-circle mx-2 list-border"
          />
          <ish-lazy-product-add-to-wishlist
            displayType="icon"
            cssClass="btn-link product-list-action-buttons btn-circle "
          />
        </div>
        <div class="product-list-add-to-cart">
          <ish-product-add-to-basket />
        </div>
      </div>
    </div>
  </div>
</div>
} }
